// firebaseInit.js
// Import the core firebase app and other services as they were typically imported in Firebase v8
import firebase from 'firebase/app';
import 'firebase/auth'; // Import auth service for side effects
import 'firebase/firestore'; // Import firestore service for side effects
import 'firebase/database'; // Import database service for side effects

// Import the configurations for both projects
import { defaultFirebaseConfig, customerProfileFirebaseConfig } from './firebaseConfig';

// Initialize the DEFAULT Firebase App
// Check if a default app already exists to prevent re-initialization errors
// For Firebase v8, you might not use getApps() or getApp() in the same way.
// Instead, initialize it directly, and Firebase handles the default instance.
const defaultFirebaseApp = firebase.initializeApp(defaultFirebaseConfig);

// Initialize the 'CustomerProfile' Firebase App
// Provide a name for the second app (e.g., 'CustomerProfile')
// This allows you to differentiate and access services from this specific app.
const customerProfileFirebaseApp = firebase.initializeApp(customerProfileFirebaseConfig, 'CustomerProfile');


// Export the Firebase services for both apps
export default {
  // Services for the DEFAULT app
  default: {
    // Access services from the default app instance using Firebase v8 syntax
    rdb: defaultFirebaseApp.database(),
    db: defaultFirebaseApp.firestore(),
    auth: firebase.auth(defaultFirebaseApp), // For auth, often accessed via firebase.auth() but can be scoped to an app
  },
  // Services for the 'CustomerProfile' app
  customerProfile: {
    // Access services from the named app instance using Firebase v8 syntax
    rdb: customerProfileFirebaseApp.database(),
    db: customerProfileFirebaseApp.firestore(),
    auth: firebase.auth(customerProfileFirebaseApp), // Scoped to the 'CustomerProfile' app
  }
};
